export const GET_CURRENT_ROOT_ENTITY = "GET_CURRENT_ROOT_ENTITY";
